import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {OrganizationService} from "../../../../../service-data/organization.service";
import {Organization} from "../../../../../../model/Organization";
import {ProjectFolders} from "../../../../../../model/supporting/ProjectFolders";
import {Util} from "../../../../../util/Util";
import {ProjectService} from "../../../../../service-data/project.service";
import {debounceTime} from "rxjs/operators";
import {LanguagePipe} from "../../../../../pipe/language.pipe";

@Component({
  selector: 'app-rename-project-folder',
  templateUrl: './rename-project-folder.component.html',
  styleUrls: ['./rename-project-folder.component.css']
})
export class RenameProjectFolderComponent implements OnInit {
  public breakpoint: number; // Breakpoint observer code
  public newFolderName: string;
  public changeForm: FormGroup;
  wasFormChanged = false;
  organization: Organization;
  selectedFolder: string;
  projectFolders: ProjectFolders;
  /** Set when ProjectFolders refuses the rename; keeps the dialog open. */
  errorMessage: string = '';

  protected readonly Util = Util;

  constructor(private formBuilder: FormBuilder, public dialog: MatDialog, public organizationService: OrganizationService, private projectService: ProjectService,  @Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<RenameProjectFolderComponent>) {
    // Get data passed in
    if ( data.organization ) {
      this.organization = data.organization;
      this.projectFolders = this.organization.getProjectFolders();
      this.selectedFolder = data.selectedFolder;
      this.newFolderName = Util.getLastItem(this.selectedFolder, '/');
    }
  }

  public ngOnInit(): void {
    // this.organizationService.getItems()
    //   .subscribe(organizations => {
    //     this.organization = organization;
    //   });

    const dirNameRegex = /^(?!(?:CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])(?:\.[^.]*)?$)[^<>:"/\\|?*\x00-\x1F]*[^<>:"/\\|?*\x00-\x1F .]$/;
    this.changeForm = this.formBuilder.group({
      newFolderName: [this.newFolderName, [Validators.required, Validators.pattern(dirNameRegex)]]
    });
    this.breakpoint = window.innerWidth <= 600 ? 1 : 2; // Breakpoint observer code
    this.changeForm.get('newFolderName').valueChanges.pipe(debounceTime(300)) // Wait 300ms after the last keystroke
      .subscribe(() => this.update());
  }


  public onChange(): void {
    this.errorMessage = '';
    if ( this.projectFolders ) {
      try {
        const currentLeafFolderName = Util.getLastItem(this.selectedFolder, '/');
        const currentParentFolder = this.selectedFolder.substring(0, this.selectedFolder.length - currentLeafFolderName.length - 1);
        // Throws on collision. This used to overwrite the folder it collided
        // with, silently discarding that folder's entire subtree.
        this.projectFolders.renameFolder(currentParentFolder, currentLeafFolderName, this.changeForm.value['newFolderName']);
        const newFullFolderName = this.selectedFolder.substring(0, this.selectedFolder.length - currentLeafFolderName.length) + this.changeForm.value['newFolderName'];
        this.projectService.moveProjectsInFolder(this.selectedFolder, newFullFolderName).subscribe( x => {
          console.log(`Rename Folder ${this.selectedFolder} currentFolder[${currentLeafFolderName}] newFolder[${this.changeForm.value['newFolderName']}]`);
        });
        this.organization.setProjectFolders(this.projectFolders);
        this.organizationService.updateItem(this.organization).subscribe( x => {
          console.log(`Rename Folder completed ${this.selectedFolder}`);
        });
      } catch ( e ) {
        // Keep the dialog open: closing it implied the rename had happened.
        console.log(`Rename Folder not completed ${this.selectedFolder}`, e);
        this.errorMessage = LanguagePipe.get('A folder with that name already exists here.', 'compressSpaces');
        return;
      }
    }

    const returnObject = {};
    // returnObject['selectedFilterValue'] = this.form.controls.selectedFilterValue.value;
    // returnObject['selectedFilter'] = this.form.controls.selectedFilter.value;

    this.markAsDirty(this.changeForm);
    this.dialogRef.close(returnObject);
  }

  public update(): void {
    this.newFolderName = this.changeForm.value['newFolderName'];
    this.markAsDirty(this.changeForm);
  }

  /**
   * The folder name as it should read on the action button.
   *
   * Read straight off the control rather than the `newFolderName`
   * mirror, which only {@link update} refreshes — see the matching
   * getter on CreateProjectFolderComponent. The button states what the
   * rename will produce, so it must never lag the field it describes.
   */
  get folderNameLabel(): string {
    const control = this.changeForm ? this.changeForm.get('newFolderName') : null;
    const value = control ? control.value : this.newFolderName;
    return value ? String(value) : '';
  }


  // tslint:disable-next-line:no-any
  public onResize(event: any): void {
    this.breakpoint = event.target.innerWidth <= 600 ? 1 : 2;
  }

  private markAsDirty(group: FormGroup): void {
    group.markAsDirty();
    // tslint:disable-next-line:forin
    for (const i in group.controls) {
      group.controls[i].markAsDirty();
    }
  }

  formChanged() {
    this.wasFormChanged = true;
  }

  handleSelection(name: string) {
    this.newFolderName = name;
    console.log('User selected:', name);
  }
}
